import { RuntimeVariables } from "@nts/std/types";
import { EnumItemInterface } from '../../../view-models/base-type/enum-property-view-model';

export class FilterVariableViewModel implements EnumItemInterface {
    key: RuntimeVariables;
    description: string;
    descriptionExt: string;

    constructor(value: RuntimeVariables, label: string) {
        this.key = value;
        this.description = label;
        this.descriptionExt = '';
    }
}
